// ProductForm – add to cart puis rafraîchit le tiroir via renderContents (fallback si absent)
class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    if (!this.form) return;
    this.submitBtn = this.querySelector('[type="submit"]');
    this.form.addEventListener('submit', this.onSubmit.bind(this));
  }

  onSubmit(e) {
    e.preventDefault();
    if (this.submitBtn) this.submitBtn.setAttribute('disabled', 'disabled');

    const payload = JSON.stringify({
      id: this.form.querySelector('[name="id"]').value,
      quantity: Number(this.form.querySelector('[name="quantity"]')?.value || 1),
      properties: this.collectProperties()
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: payload,
      credentials: 'same-origin'
    })
      .then(r => { if (!r.ok) return r.json().then(e => { throw e; }); return r.json(); })
      .then(() => this.refreshDrawer())
      .then(() => { window.CORNICHON_COLD_PACK?.ensureThermal?.(); })
      .catch(err => { console.warn('[product-form] add error', err); this.showError(err); })
      .finally(() => { if (this.submitBtn) this.submitBtn.removeAttribute('disabled'); });
  }

  collectProperties() {
    const props = {};
    this.form.querySelectorAll('[name^="properties"]').forEach((el) => {
      const m = el.name.match(/^properties\[(.*)\]$/);
      if (m) props[m[1]] = el.value;
    });
    return props;
  }

  async refreshDrawer() {
    const ids = ['cart-drawer', 'cart-icon-bubble'];

    // 1) JSON sections + appel direct au composant du tiroir
    try {
      const jsonUrl = `/?sections=${ids.join(',')}&sections_url=/cart`;
      const sections = await fetch(jsonUrl, { credentials: 'same-origin', cache: 'no-store' }).then(r => r.json());

      const drawerEl = document.querySelector('cart-drawer');
      if (drawerEl?.renderContents) {
        drawerEl.renderContents({
          id: Date.now(),
          sections: {
            'cart-drawer': sections['cart-drawer'] || '',
            'cart-icon-bubble': sections['cart-icon-bubble'] || ''
          }
        });
        return; // la méthode open() est déjà appelée par le composant
      }

      // Pas de renderContents → on injecte à la main (cross-case safe)
      this.manualInject(sections);
      this.openDrawer();
      return;
    } catch (e) {
      console.warn('[product-form] JSON sections failed → fallback HTML', e);
    }

    // 2) Fallback HTML (section_id)
    try {
      const htmlDrawer = await fetch('/cart?section_id=cart-drawer', { credentials: 'same-origin', cache: 'no-store' }).then(r => r.text());
      const htmlBubble = await fetch('/?section_id=cart-icon-bubble&sections_url=/cart', { credentials: 'same-origin', cache: 'no-store' }).then(r => r.text());

      const sections = {
        'cart-drawer': htmlDrawer,
        'cart-icon-bubble': htmlBubble
      };
      this.manualInject(sections);
      this.openDrawer();
    } catch (e) {
      console.warn('[product-form] HTML fallback failed', e);
    }
  }

  manualInject(sections) {
    const inject = (id) => {
      const html = sections[id]; if (!html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const innerSel = (id === 'cart-drawer') ? '#CartDrawer' : '#cart-icon-bubble';

      const srcRoot  = doc.getElementById(`shopify-section-${id}`) || doc.querySelector('.shopify-section') || doc.body;
      const srcInner = doc.querySelector(innerSel) || (srcRoot ? srcRoot.querySelector(innerSel) : null);

      const tgtInner = document.querySelector(innerSel);
      const tgtRoot  = document.getElementById(`shopify-section-${id}`);

      if (tgtInner && srcInner) {
        tgtInner.innerHTML = srcInner.innerHTML;
      } else if (tgtInner && srcRoot) {
        // <<< CROSS-CASE : la réponse ne contient que le wrapper → on extrait le sous-élément
        const sub = srcRoot.querySelector(innerSel) || srcRoot;
        tgtInner.innerHTML = sub.innerHTML;
      } else if (tgtRoot && srcRoot) {
        tgtRoot.innerHTML = srcRoot.innerHTML;
      }
    };

    inject('cart-drawer');
    inject('cart-icon-bubble');
  }

  openDrawer() {
    const drawerEl = document.querySelector('cart-drawer');
    if (!drawerEl) return;
    // Nettoyage état "vide"
    drawerEl.querySelector('.drawer__inner')?.classList.remove('is-empty');
    // Utilise l’API du composant si dispo
    if (typeof drawerEl.open === 'function') {
      drawerEl.open();
    } else {
      drawerEl.classList.add('animate', 'active');
      document.body.classList.add('overflow-hidden');
    }
  }

  showError(err) {
    const wrap = this.querySelector('.product-form__error-message');
    const out = typeof err === 'string' ? err : (err?.message || 'Error');
    if (wrap) wrap.textContent = out;
  }
}
customElements.define('product-form', ProductForm);
